$(document).ready(function() {
	$('.accordion').on('click', function() {
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
		} else {
			$('.accordion:not(.filter-heading)').removeClass('active');
			$(this).addClass('active');
		}

	});
	$(".product_options input").on('change',function(e){
		var input = $(this);
		if(e.target.getAttribute('name') === 'orderby') {
			$('.product_options.orderby label').removeClass('active');
			$('#product_filters_orderby_title').text(input.data('name'));
			input.parent().addClass('active');
			return;
		}
		if(input.is(':checked')) {
			input.parent().addClass('active');
			$('#active_values').append(`<p data-name='${input.val()}'>${input.data('name')}<span></span></p>`);
		} else {
			input.parent().removeClass('active');
			$('#active_values p[data-name="' + input.val() +'"]').remove();
		}
		if ($('#active_values').children().length > 1) {
			$("#reset_filter").show();
		} else {
			$("#reset_filter").hide();
		}
	})
})

if(document.getElementById("min_price")){
	document.getElementById("min_price").addEventListener("keyup", valuesCompare);
}
if(document.getElementById("max_price")){
	document.getElementById("max_price").addEventListener("keyup", valuesCompare);
}
function valuesCompare() {
  var min_val = document.getElementById("min_price");
  var max_val = document.getElementById("max_price");
  if (!min_val.value.match(/^[0-9]+$/)){
	min_val.value = min_val.value.replace(/[^\d]/g,'');
  } else if (!max_val.value.match(/^[0-9]+$/)){
	max_val.value = max_val.value.replace(/[^\d]/g,'');
  } 
  if ((min_val.value > max_val.value) || (min_val.value === max_val.value)) {
    max_val.style.borderColor = "red";
  } else {
	max_val.style.borderColor = "inherit";
  }
}
const handlePopper = (filterOptionsNames, filterOptionsBlocks) => {
	let popper = Popper.createPopper(filterOptionsNames, filterOptionsBlocks, {
	  placement: "bottom-start",
	  modifiers: [
		{
		  name: 'offset',
		  options: {
			offset: [0, 10],
		  },
		},
	  ],
	});
	return popper;
  };

const popperFilters = () => {
	let filterElements = document.querySelectorAll(".product_options");
	filterElements.forEach((item) => {
		let filterOptionsNames = item.querySelector(".accordion");
		let filterOptionsBlocks = item.querySelector(".options");
		handlePopper(filterOptionsNames,filterOptionsBlocks);
	})
}
popperFilters();
